var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.324,
    height: 24.324,
    viewBox: "0 0 24.324 24.324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#9a9a9a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M136.251,134.576l-7.9-7.9a9.114,9.114,0,1,0-1.678,1.678l7.9,7.893a.249.249,0,0,0,.353,0l1.326-1.323A.249.249,0,0,0,136.251,134.576Zm-10.313-8.638a6.812,6.812,0,1,1,1.995-4.816A6.774,6.774,0,0,1,125.938,125.938Z",
    transform: "translate(-112 -112)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.70f37c89033a78f0c900054e8a546b5c.svg";
export { ForwardRef as ReactComponent };